<template>
  <div class="pdfcls">
    <el-dialog :title="title" custom-class="pdfmodelcls" :visible.sync="showfdfmodel" width="100%" top="0px" height  center>
      <div v-loading="pdfLoading" class="ifamebox">
        <iframe :src="iframeSRC" :id="iframeID" width="1148px" style="height:80%;">
        </iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import {getActionPDF} from "../../../api/manage";


import requests from "@/api/resquest"
  export default {
    name: "PDFModal",
    props: {
      iframeID: {
        type: String,
        default: 'iframeID'
      },
      title: {
        type: String,
        default: '预览'
      },
      PDFurl: {
        type: String,
        default: 'http://162.14.122.251/ky'
      },
      showmodel: {
        type: Boolean,
        default: false
      },


    },
    data() {
      return{
        pdfLoading: true,
        iframeSRC:'',
        showfdfmodel:false,
      }
    },

    mounted() {
      },
    watch:{
      showmodel(isshow){
        console.log('showmodel',isshow)
        if(isshow){
          this.loadPDF();
          this.showfdfmodel=true;
        }
      },
      showfdfmodel(isshowfdf){
        if(isshowfdf){
          this.$emit('closepdfmodel')
        }
      },
    },
    methods: {
      //  自定义   getPDF
    getActionPDF(url, parameter) {
      return requests({
        url: url,
        method: 'get',
        params: parameter,
        responseType: 'blob',
      })
    },
      loadPDF() {
        this.iframeSRC='';
        this.getActionPDF(this.PDFurl).then((res) => {
          console.log(res,79)
          let blobPDF = new Blob([res], {
            type: `application/pdf;charset-UTF-8` // word文档为msword,pdf文档为pdf
          });
          console.log(blobPDF)
          this.iframeSRC = window.URL.createObjectURL(blobPDF);
          console.log(this.iframeSRC)
          this.pdfLoading = false;
          // 重点
        }).catch((err) => {
          });

      }
    }

  }
</script>

<style lang="less" >
 iframe{
   position:absolute;
   z-index:1
 }
 .ifamebox{
   height: 200px;
 }
  .adiv{
    text-align: center;
    position:absolute;
    z-index:10;
    width:var(--width);
    height: 100%;
  }
  .aspin{
    height: 100%;
    line-height:50%;
  }
  .pdfcls{
    width: 100%;
    height: 100%;
  }
  .el-dialog__wrapper{
    width: 1200px;
    margin: 0 auto;
    margin-top: 40px;
    height: 90%;
    .el-dialog__body{
      height: 80%;
    }
    .el-dialog__header{
      box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
    }
    .el-dialog{
          box-shadow:0 0px 0px #ffffff;
          margin: 0 auto;
          height: 100%;
    }
    .el-dialog__body{
      // padding: 0;
    }
  }
  .el-dialog.el-dialog--center{
      margin-top: 0px !important;
    }
</style>